import { createContext } from 'react';
import { AuthContextInterface } from './AuthContextInterface';

const AuthContext: any = createContext<AuthContextInterface<any>>({
  authUser: undefined,
  setAuthUser: () => null,
  clearAuthUser: () => null,
  authUserLoading: false,
});

export default AuthContext;
